// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { User } from '@/types/User';

export interface AuthStoreState {
    currentUser: User | null;
    token: string | null;
    loginRedirect: string | null;
}

export function createAuthStore(): any {
    return {
        namespaced: true,
        state: {
            currentUser: null,
            token: null,
            loginRedirect: null,
        } as AuthStoreState,
        getters: {
            isAdmin(state: AuthStoreState): boolean {
                return !!(state.currentUser && state.currentUser.admin);
            },

            isModerator(state: AuthStoreState): boolean {
                return !!(state.currentUser && state.currentUser.moderator);
            },
        },
        mutations: {
            setUser(state: AuthStoreState, payload: any): void {
                state.currentUser = payload ? payload.user : null;
                state.token = payload ? payload.token : null;
            },

            updateUser(state: AuthStoreState, payload: any): void {
                if (payload.hasOwnProperty('user')) {
                    state.currentUser = payload.user;
                }
                if (payload.hasOwnProperty('token')) {
                    state.token = payload.token;
                }
            },

            setLoginRedirect(state: AuthStoreState, value: string | null): void {
                state.loginRedirect = value;
            },
        },
    };
}
